<template>
  <div style="min-height: 800px; background: #13161b">
    <div class="BlockList">
      <div class="BlockList-W" v-show="codefloag">
        <div class="Contract">
          <div class="Contract_tit"><span>Contract Deployment</span></div>
          <div class="Contract_con">
            <div class="Contract_icon"></div>
            <div class="Contract_content">
              Contract Deployment is the process of deploying your smart
              contract code to the blockchain network. You can compile and
              deploy smart contract by uploading the smart contract file. Please
              note that contract deployment will consume a certain amount of
              TTOS, so make sure your account balance is sufficient.
            </div>
          </div>
          <div class="Contract_con1">
            <el-form ref="form" :model="form" :rules="rules">
              <div class="Contractbox">
                <div class="Contractboxs">
                  <div class="Contractboxli">
                    <div class="Contractboxli_tit">Compiler Version:</div>
                    <!-- <div class="Contractboxli_con">
                      <el-form-item
                        prop="compileVersion"
                        style="
                          background-color: #000 !important;
                          padding: 0px !important;
                          margin: 0px !important;
                        "
                      >
                        <el-select
                          v-model="form.compileVersion"
                          placeholder="Please select"
                          class="inpttext"
                          style="
                            background-color: #000 !important;
                            border: none;
                          "
                        >
                          <el-option
                            v-for="item in options1"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            style="
                              background-color: #000 !important;
                              padding-top: 10px;
                              padding: 0px !important;
                            "
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div> -->
                    <div class="verfery_li">
                      <div class="verfery_licon">
                        <el-form-item
                          prop="compileVersion"
                          style="
                            background-color: #13161b !important;
                            padding: 0px !important;
                            margin: 0px !important;
                            z-index: 9;
                          "
                        >
                          <el-select
                            v-model="form.compileVersion"
                            placeholder="Please select"
                            :popper-append-to-body="false"
                            class="inpttext"
                            style="
                              background-color: #13161b !important;
                              border: none !important;
                            "
                            @visible-change="handleCompileVersionVisibleChange"
                          >
                            <el-option
                              v-for="item in options1"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              style="
                                background-color: #13161b !important;
                                /* padding-top: 10px; */
                              "
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="Contractboxli">
                    <div class="Contractboxli_tit">Protocol standards:</div>
                    <div class="verfery_li">
                      <div class="verfery_licon">
                        <el-form-item
                          prop="standard"
                          style="
                            background-color: #13161b !important;
                            padding: 0px !important;
                            margin: 0px !important;
                            z-index: 9;
                          "
                        >
                          <el-select
                            v-model="form.standard"
                            placeholder="Please select"
                            :popper-append-to-body="false"
                            class="inpttext"
                            style="
                              background-color: #13161b !important;
                              border: none !important;
                            "
                            @visible-change="handleCompileVersionVisibleChange1"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              style="
                                background-color: #13161b !important;

                                height: 36px;
                                line-height: 36px;
                              "
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
             
                  </div> -->
                </div>
                <div class="Contractboxlis">
                  <div class="Contractboxli_tits">
                    <div class="Contractboxli_titsl">Contract Code</div>

                    <el-upload
                      accept=".sol, .txt, .text"
                      action="https://explorer.tfsc.io/tfscBrowser/contract/uploadSolFile"
                      :limit="1"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="upSuccess"
                      :on-error="upError"
                      ref="upload"
                    >
                      <el-button size="small">
                        <span class="iconfont icon-shangchuan" /><img
                          src="@/assets/pc/Index/upload.png"
                        />
                        Upload file
                      </el-button>
                    </el-upload>
                    <!-- <div class="Contractboxli_titsr"> <img src="@/assets/pc/Index/upload.png" /> Upload file</div> -->
                  </div>
                  <div class="Contractboxli_cons">
                    <!-- <el-form-item prop="sourceCode"> -->
                    <editor
                      v-model="form.sourceCode"
                      @init="editorInit"
                      @input="codeChange"
                      lang="java"
                      :options="editorOptions"
                      theme="github"
                    ></editor>
                    <!-- </el-form-item> -->
                  </div>
                  <!-- 展示成功或失败的弹出内容开始 -->
                  <div class="Contractboxli_consa">
                    <div class="Contractboxli_header" v-show="success">
                      <div class="con_tit">Compiled success:</div>
                      <div class="con_con">Contract Mytoken</div>
                      <div class="con_btn" @click="showAbi">Show ABI</div>
                      <div class="con_btn con_btn1" @click="showByte">
                        Show Bytecode
                      </div>
                    </div>
                    <div class="Contractboxli_content">
                      <!-- <div class="con_cont1">Deploy MyToken</div>
                      <div class="con_cont2">
                        Transaction unsigned.
                        <div class="con_conbtton">
                          View Unsigned Transaction
                        </div>
                      </div> -->
                      <!-- <div class="con_cont3">Waiting user sign</div> -->
                      <div class="con_cont4">
                        {{ codeerror }}
                      </div>
                    </div>
                  </div>
                  <!-- 展示成功或失败的弹出内容开始 -->
                </div>
                <div class="Contractboxli_button">
                  <div
                    @click="submitForm"
                    :disabled="isDisabled"
                    :class="
                      isDisabled == false || isDisableda == false
                        ? 'button'
                        : 'button1'
                    "
                  >
                    Compile
                  </div>
                  <div
                    :class="isDisableda == true ? 'button' : 'button1'"
                    :disabled="isDisableda"
                    @click="Deploy"
                  >
                    Deploy
                  </div>
                </div>
              </div>
            </el-form>

            <el-dialog
              title=""
              :visible.sync="centerDialogVisible"
              width="975px"
              center
            >
              <div class="elheader"><span>Compiled error:</span></div>
              <div class="elcontent"></div>
              <!-- <span>需要注意的是内容是默认不居中的</span> -->
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false"
                  >Confirm</el-button
                >
              </span>
            </el-dialog>
          </div>
        </div>
        <div class="tankuangbox" v-show="flogs">
          <div class="tankuanglist">
            <div class="tankuanghead">
              <div class="tantit">Deploy Params</div>
              <img src="@/assets/pc/Index/close.png" @click="close" />
            </div>
            <div class="tankuangconts">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm">
                <!-- <div class="verfery_li">
                  <div class="verfery_litit">Contract Name:</div>
                  <div class="verfery_licon">
                    <el-form-item
                      prop="contractName"
                    
                    >
                      <el-input
                        v-model="dynamicValidateForm.contractName"
                        placeholder="string"
                        class="inpttext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div> -->

                <div class="verfery_li">
                  <div class="verfery_litit">Params for constructor</div>
                  <div
                    class="verfery_licon1"
                    v-for="(item, index) in inputs"
                    :key="index"
                  >
                    <div v-if="item.type == 'string'" style="display: flex">
                      <div class="vername">{{ item.name }}</div>
                      <el-form-item :prop="item.name">
                        <el-input
                          v-model.trim="item.value"
                          class="inpttext1"
                          placeholder="string"
                        ></el-input>
                      </el-form-item>
                    </div>

                    <div v-if="item.type == 'uint8'" style="display: flex">
                      <div class="vername">{{ item.name }}</div>
                      <el-form-item :prop="item.name">
                        <el-input
                          v-model.number="item.value"
                          class="inpttext1"
                          placeholder="uint8"
                          @input="inputvalue"
                          maxlength="2"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div v-if="item.type == 'uint256'" style="display: flex">
                      <div class="vername">{{ item.name }}</div>

                      <el-form-item
                        :prop="item.name"
                        v-if="item.name !== '_totalSupply'"
                      >
                        <el-input
                          v-model="item.value"
                          @input="inputvalue"
                          class="inpttext1"
                          placeholder="uint256"
                          maxlength="18"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :prop="item.name"
                        v-if="
                          item.name == '_totalSupply' ||
                          item.name == 'totalSupply'
                        "
                      >
                        <el-input
                          v-if="nftvalue == true"
                          v-model="item.value"
                          @input="handleInput"
                          class="inpttext1"
                          placeholder="uint256"
                          maxlength="5"
                        ></el-input>
                        <el-input
                          v-if="nftvalue == false"
                          v-model="item.value"
                          @input="handleInput"
                          class="inpttext1"
                          placeholder="uint256"
                          maxlength="36"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <!-- 提示错误消息开始 -->
                  <div class="errorbox">{{ error }}</div>
                  <!-- 提示错误消息结束 -->
                  <div class="btnflex">
                    <div
                      style="display: flex; position: absolute"
                      v-show="showtip"
                    >
                      <div class="tip">
                        <div class="tipcon">
                          Copy the encoded<br />input parameters to <br />verify
                          the contract.
                        </div>
                      </div>
                      <span class="arrow"></span>
                    </div>
                    <div
                      style="width: 300px; display: flex; margin-left: 163px"
                    >
                      <!-- <button @click="copyText">复制文本</button> -->
                      <div
                        class="verfery_copy"
                        @mouseover="handleMouseOver"
                        @mouseout="handleMouseOut"
                        v-if="inputsa.length > 0"
                        @click="getABIInputEncodeData"
                      >
                        <img src="@/assets/pc/BkHash/copy.png" class="copys" />
                        <div>Parameters</div>
                      </div>
                      <div
                        class="verfery_btn"
                        @click="Confirm1('dynamicValidateForm')"
                      >
                        Confirm
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="tankuangbox" v-show="flogsa">
          <div class="tankuanglist">
            <div class="tankuanghead">
              <div class="tantit">Show ABI</div>
              <img src="@/assets/pc/Index/close.png" @click="close1" />
            </div>
            <div class="tankuangconts">
              <el-form>
                <el-form-item>
                  <el-input type="textarea" v-model="showabi"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="tankuang_btn">
              <div class="tan_close" @click="close1">Close</div>
              <div
                class="tan_copy"
                v-clipboard:copy="showabi"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                Copy
              </div>
            </div>
          </div>
        </div>
        <div class="tankuangbox" v-show="flogsb">
          <div class="tankuanglist">
            <div class="tankuanghead">
              <div class="tantit">Show Bytecode</div>
              <img src="@/assets/pc/Index/close.png" @click="close2" />
            </div>
            <div class="tankuangconts">
              <el-form>
                <div style="display: flex">
                  <div
                    style="
                      font-size: 16px;
                      font-family: Roboto, Roboto;
                      font-weight: 400;
                      color: #fff;
                    "
                  >
                    root:
                  </div>
                  <div style="width: 460px">
                    <el-form-item>
                      <el-input type="textarea" v-model="showbyte"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="tankuang_btn">
              <div class="tan_close" @click="close2">Close</div>
              <div
                class="tan_copy"
                v-clipboard:copy="showbyte"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                Copy
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="BlockList-Wa" v-show="codefloaga">
        <!-- 连接插件钱包开始 -->
        <div class="Connection" v-show="flagc">
          <div class="Connection_w">
            <div class="Connection_box">
              <div class="Connection_tit">Select Connection Method</div>
              <div class="Connection_erwm">
                <div class="con_box" @click="Walletconnet">
                  <div class="treeimg">
                    <!-- <img src="@/assets/pc/Index/tree.png" /> -->
                  </div>
                  <!-- <div class="treetit">
                    Tree Wallet for<br />
                    Chrome
                  </div> -->
                </div>
                <!-- <div class="con_box1">
                  <div class="treeimg1">
                    <img src="@/assets/pc/Index/tree1.png" />
                  </div>
                  <div class="treetit1">
                    Scan the QR code<br />
                    on the mobile<br />
                    device
                  </div>
                </div> -->
              </div>
              <div class="Connection_botm">
                If you haven't installed Tree Wallet, please install first, then
                refresh the page and try again.
                <a
                  href="https://chromewebstore.google.com/detail/tree-wallet/bpmfdameiilkdfnccjjhjgidcbckccmn"
                  target="__blank"
                  ><span>Install Now</span></a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 连接插件钱包结束 -->
        <div class="paidbox" v-show="flagd">
          <div class="paidboxlist">
            <div class="paidboxtit">
              Please use Tree Wallet to scan the QR code below to complete the
              payment to<br />
              successfully complete the contract release process
            </div>
            <div class="qrcodea">
              <div ref="qrcode" id="qrcode" class="qrcode"></div>
            </div>
            <div class="button" @click="paids">I scanned and paid</div>
            <div class="bottom" @click="black">
              <div class="bottomtit">Back to Contract Deployment</div>
              <img
                src="../../../assets/pc/Index/right.png"
                style="width: 16px; height: 16px; margin-top: 4px"
              />
            </div>
          </div>
        </div>
        <div class="paidbox1" v-show="flaga">
          <div class="paidboxlist">
            <div class="paidtit1">
              Congratulations! Your contract has been successfully published!
            </div>
            <div class="paidtit2">
              You can view your contract through the Transformers<br />
              browser.
            </div>
            <div class="paidtitbtn" @click="black">OK</div>
          </div>
        </div>
        <div class="paidbox2" v-show="flagb">
          <div class="paidboxlist">
            <div class="paidtit1">
              I'm sorry, but your contract information has not been detected
              yet<img
                style="
                  width: 24px;
                  height: 24px;
                  margin-left: 15px;
                  cursor: pointer;
                "
                @click="paids"
                src="@/assets/pc/Logo/sua.png"
              />
            </div>
            <div class="paidtit2">
              This may be due to the following reasons:
            </div>
            <div class="paidtit3">
              1.Network delay, please try refreshing the page and resubmitting
              your request.
            </div>
            <div class="paidtit3">
              2. Please confirm that your Tree Wallet has successfully scanned
              the QR code, completed the payment. and successfully published the
              contract.
            </div>
            <div class="paidtitbtn" @click="erweima">OK</div>
            <div class="paidtitbottom" @click="black">
              <div class="bottomtit">Back to Contract Deployment</div>
              <img
                src="../../../assets/pc/Index/right.png"
                style="width: 16px; height: 16px; margin-top: 4px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clipboard from "clipboard";
import QRCode from "qrcodejs2";
import Editor from "vue2-ace-editor";
import axios from "axios";
// //黑底色
// import "brace/theme/tomorrow_night_eighties";
// //蓝底色
// import "brace/theme/tomorrow_night_blue";
//黑底色
// import "brace/theme/vibrant_ink";
//白底色黑字  不带高亮
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
import "brace/theme/github";
import { isPositiveInteger } from "@/utils/utils";
import { GetvertifyContract } from "@/assets/server/api";
export default {
  data() {
    return {
      coderesult: "",
      contentFilled: false,
      showtip: false,
      nftshow: false,
      nftvalue: false,
      error: "",
      totalSupply: "",
      numbers: "",
      numbersa: "000000000000000000",
      codeerror: "",
      flaga: false,
      flagb: false,
      flagc: false,
      flagd: false,
      isReadOnly: true,
      success: false,
      flog: false,
      flogs: false,
      flogsa: false,
      flogsb: false,
      codefloag: true, //生成二维码页面
      codefloaga: false,
      centerDialogVisible: false,
      centerDialogVisiblea: true,
      isDisabled: false,
      isDisableda: false,
      inputs: [],
      inputsa: [],
      contractUUID: "",
      // contractName: "",
      Address: "",
      inputJson: [],
      showabi: "",
      showbyte: "",
      imgnamef: require("@/assets/pc/TopValidators/fail.png"),
      form: {
        compileVersion: "", //第一个名字
        // standard: "",
        sourceCode: "",
        // lastName: "", //最后一个名字
      },
      rules: {
        compileVersion: [
          {
            required: true,
            message: "Compiler Version  is required",
            trigger: "change",
          },
        ],
        // standard: [
        //   {
        //     required: true,
        //     message: "Protocol standards is required",
        //     trigger: "change",
        //   },
        // ],
      },
      dynamicValidateForm: {
        // contractName: "",
        // name: "",
        // symbol: "",
        decimals: "",
        totalSupply: "",
      },
      forma: {
        contractUUID: "",
        inputJson: [],
        contractName: "",
        // lastName: "", //最后一个名字
      },
      options: [
        {
          value: "ERC-721",
          label: "ERC-721",
        },
        {
          value: "ERC-20",
          label: "ERC-20",
        },
      ],
      options1: [
        {
          value: "0821",
          label: "v0.8.21+commit.d9974bed",
        },
        {
          value: "0820",
          label: "v0.8.20+commit.a1b79de6",
        },
        {
          value: "0819",
          label: "v0.8.19+commit.7dd6d404",
        },
        {
          value: "0818",
          label: "v0.8.18+commit.87f61d96",
        },
        {
          value: "0817",
          label: "v0.8.17+commit.8df45f5f",
        },
        {
          value: "0816",
          label: "v0.8.16+commit.07a7930e",
        },
        {
          value: "0815",
          label: "v0.8.15+commit.e14f2714",
        },
        {
          value: "0814",
          label: "v0.8.14+commit.80d49f37",
        },
        {
          value: "0813",
          label: "v0.8.13+commit.abaa5c0e",
        },
        {
          value: "0812",
          label: "v0.8.12+commit.f00d7308",
        },
        {
          value: "0811",
          label: "v0.8.11+commit.d7f03943",
        },
        {
          value: "0810",
          label: "v0.8.10+commit.fc410830",
        },
        {
          value: "089",
          label: "v0.8.9+commit.e5eed63a",
        },
        {
          value: "088",
          label: "v0.8.8+commit.dddeac2f",
        },
        {
          value: "087",
          label: "v0.8.7+commit.e28d00a7",
        },
        {
          value: "086",
          label: "v0.8.6+commit.11564f7e",
        },
        {
          value: "085",
          label: "v0.8.5+commit.a4f2e591",
        },
        {
          value: "084",
          label: "v0.8.4+commit.c7e474f2",
        },
        {
          value: "083",
          label: "v0.8.3+commit.8d00100c",
        },
        {
          value: "082",
          label: "v0.8.2+commit.661d1103",
        },
        {
          value: "081",
          label: "v0.8.1+commit.df193b15",
        },
        {
          value: "080",
          label: "v0.8.0+commit.c7dfd78e",
        },
        {
          value: "076",
          label: "v0.7.6+commit.7338295f",
        },
        {
          value: "075",
          label: "v0.7.5+commit.eb77ed08",
        },
        {
          value: "074",
          label: "v0.7.4+commit.3f05b770",
        },
        {
          value: "073",
          label: "v0.7.3+commit.9bfce1f6",
        },
        {
          value: "072",
          label: "v0.7.2+commit.51b20bc0",
        },
        {
          value: "071",
          label: "v0.7.1+commit.f4a555be",
        },
        {
          value: "070",
          label: "v0.7.0+commit.9e61f92b",
        },
        {
          value: "0612",
          label: "v0.6.12+commit.27d51765",
        },
        {
          value: "0611",
          label: "v0.6.11+commit.5ef660b1",
        },
        {
          value: "0610",
          label: "v0.6.10+commit.00c0fcaf",
        },
        {
          value: "069",
          label: "v0.6.9+commit.3e3065ac",
        },
        {
          value: "068",
          label: "v0.6.8+commit.0bbfe453",
        },
        {
          value: "067",
          label: "v0.6.7+commit.b8d736ae",
        },
        {
          value: "066",
          label: "v0.6.6+commit.6c089d02",
        },
        {
          value: "065",
          label: "v0.6.5+commit.f956cc89",
        },
        {
          value: "064",
          label: "v0.6.4+commit.1dca32f3",
        },
        {
          value: "063",
          label: "v0.6.3+commit.8dda9521",
        },
        {
          value: "062",
          label: "v0.6.2+commit.bacdbe57",
        },
        {
          value: "061",
          label: "v0.6.1+commit.e6f7d5a4",
        },
        {
          value: "060",
          label: "v0.6.0+commit.26b70077",
        },
        {
          value: "0517",
          label: "v0.5.17+commit.d19bba13",
        },
        {
          value: "0516",
          label: "v0.5.16+commit.9c3226ce",
        },
        {
          value: "0515",
          label: "v0.5.15+commit.6a57276f",
        },
        {
          value: "0514",
          label: "v0.5.14+commit.01f1aaa4",
        },
        {
          value: "0513",
          label: "v0.5.13+commit.5b0b510c",
        },
        {
          value: "0512",
          label: "v0.5.12+commit.7709ece9",
        },
        {
          value: "v0511",
          label: "v0.5.11+commit.22be8592",
        },
        {
          value: "0511",
          label: "v0.5.11+commit.c082d0b4",
        },
        {
          value: "0510",
          label: "v0.5.10+commit.5a6ea5b1",
        },
        {
          value: "v059",
          label: "v0.5.9+commit.c68bc34e",
        },
        {
          value: "059",
          label: "v0.5.9+commit.e560f70d",
        },
        {
          value: "058",
          label: "v0.5.8+commit.23d335f2",
        },
        {
          value: "057",
          label: "v0.5.7+commit.6da8b019",
        },
        {
          value: "056",
          label: "v0.5.6+commit.b259423e",
        },
        {
          value: "055",
          label: "v0.5.5+commit.47a71e8f",
        },
        {
          value: "054",
          label: "v0.5.4+commit.9549d8ff",
        },
        {
          value: "053",
          label: "v0.5.3+commit.10d17f24",
        },
        {
          value: "052",
          label: "v0.5.2+commit.1df8f40c",
        },
        {
          value: "051",
          label: "v0.5.1+commit.c8a2cb62",
        },
        {
          value: "050",
          label: "v0.5.0+commit.1d4f565a",
        },
        {
          value: "0426",
          label: "v0.4.26+commit.4563c3fc",
        },
        {
          value: "0425",
          label: "v0.4.25+commit.59dbf8f1",
        },
        {
          value: "0424",
          label: "v0.4.24+commit.e67f0147",
        },
        {
          value: "0423",
          label: "v0.4.23+commit.124ca40d",
        },
        {
          value: "0422",
          label: "v0.4.22+commit.4cb486ee",
        },
        {
          value: "0421",
          label: "v0.4.21+commit.dfe3193c",
        },
        {
          value: "0420",
          label: "v0.4.20+commit.3155dd80",
        },
        {
          value: "0419",
          label: "v0.4.19+commit.c4cbbb05",
        },
        {
          value: "0418",
          label: "v0.4.18+commit.9cf6e910",
        },
        {
          value: "0417",
          label: "v0.4.17+commit.bdeb9e52",
        },
        {
          value: "0416",
          label: "v0.4.16+commit.d7661dd9",
        },
        {
          value: "v0415",
          label: "v0.4.15+commit.8b45bddb",
        },
        {
          value: "0415",
          label: "v0.4.15+commit.bbb8e64f",
        },
        {
          value: "0414",
          label: "v0.4.14+commit.c2215d46",
        },
        {
          value: "0413",
          label: "v0.4.13+commit.0fb4cb1a",
        },
        {
          value: "0412",
          label: "v0.4.12+commit.194ff033",
        },
        {
          value: "0411",
          label: "v0.4.11+commit.68ef5810",
        },
      ],
      editorOptions: {
        // 设置代码编辑器的样式
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        //  enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        // readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },
      qrcode: {},
      time_Interval: "", // 定时器
      time_Interval_time: 60000, // 定定时器时间
      ispid: 0,
    };
  },
  components: {
    // Homeinput,

    // Homseach,
    // Listbox,
    Editor,
  },
  created() {},
  mounted() {
    // 定时刷新二维码
    // const that = this;
    // if (!this.time_Interval) {
    //   that.init();
    // }
    // this.time_Interval = window.setInterval(function () {
    //   that.init();
    // }, that.time_Interval_time);
    // this.BlockList();
    //  this.QR();
  },
  beforeRouteLeave(to, from, next) {
    window.clearInterval(this.time_Interval);
    next();
  },
  beforeDestroy() {
    window.clearInterval(this.time_Interval);
  },
  methods: {
    // copyText() {
    //   let text = "Hello World";
    //   this.$copyText(text).then(
    //     () => {
    //       alert("已复制到剪贴板！");
    //     },
    //     () => {
    //       alert("复制失败！");
    //     }
    //   );
    // },
    async Walletconnet() {
     
    //  console.log(this.inputs);

 
      if (window.treeWallet) {
      //  this.copyresults();
        try {
          await window.treeWallet.on("accountsChanged", (accounts) => {
            //console.log(accounts);
            this.address = accounts;

            // if (this.isaccounts.length == 0) {
            //   // console.log("我断开链接了");

            // } else {
            //   this.address = accounts;
            // }
          });
        } catch (err) {
          this.$message(err);
        }
      }
    //  this.copyresults();
      this.address = await window.treeWallet.connect();
      this.PublicKey = await window.treeWallet.getPublicKey();

     // console.log(this.address);
      // console.log(await window.treeWallet.connect());
      // // console.log(JSON.stringify(this.address));
      // // console.log(this.address[0]);
      // console.log(this.PublicKey);
      // console.log(this.coderesult);
      // console.log(this.showbyte);
      const tokenTransfer = {
        from: this.address.toString(),
        to: [],
        amount: "0",
        transactionBody: {
          addr: this.address.toString(),
          contract: this.showbyte,
          data: this.coderesult,
          info: "[]",
          isFindUtxo: false,
          nContractType: "0",
          pubstr: this.PublicKey,
          txInfo: "Walletinfo",
        },
        transactionType: "GetDeployContractTransaction",
        isContractTransaction: true,
        contractData: {
          function: "Deploy",
          hexData: this.showbyte,
          functionParams: {},
        },
      };
      //console.log(tokenTransfer);
      try {
        this.mitresult = await window.treeWallet.sendTransaction(tokenTransfer);
        if (this.mitresult !== undefined) {
          this.flaga = true;
          this.flagc = false;
          // this.form.compileVersion = "";
          // this.from.sourceCode = "";
          this.$refs.form.resetFields();
          this.ispid = 0;
        }
      //  console.log(this.mitresult);
      } catch (error) {
        this.$message(error);
        //console.log(error);
      }
    },
    handleMouseOver() {
      this.showtip = true;

      //  console.log(this.inputs);
      // console.log(this.inputs);
      // console.log(this.inputsa);

      // for (var i = 0; i < this.inputs.length; i++) {
      //   if (this.inputs[i].value == "") {
      //    // this.contentFilled=false;
      //    this.coderesult=null;
      //     return false;

      //   } else {

      //     this.error = "";
      //   }
      // }

      // if (!this.contentFilled) {
      //  this.contentFilled=true;
      //   this.copyresults();
      // }
      // ;
    },
    handleMouseOut() {
      this.showtip = false;
      //this.coderesult="";
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onErrora() {
      this.coderesult = null;
      clipboard.destroy();
    },
    // handleCompileVersionVisibleChange1(newValue) {
    //   const oldvalue1 = localStorage.getItem("oldstandard");

    //   // console.log(newValue);
    //   // console.log(this.form.standard);
    //   // 在这里处理值的改变
    //   if (oldvalue1 !== this.form.standard) {
    //     this.isDisabled = false;
    //   } else {
    //     this.isDisabled = true;
    //   }
    //   // else {
    //   //   this.isDisabled = true;
    //   // }
    // },
    handleCompileVersionVisibleChange(newValue) {
      //   console.log(localStorage.getItem("oldcompileVersion"));
      const oldvalue = localStorage.getItem("oldcompileVersion");
      // const oldvalue1 = localStorage.getItem("oldstandard");

      // console.log(newValue);
      // console.log(this.form.compileVersion);
      // 在这里处理值的改变
      if (oldvalue !== this.form.compileVersion) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
      // else {
      //   this.isDisabled = true;
      // }
    },
    // handleCompileVersionVisibleChange(visible) {
    //   this.isDisabled = false;
    //   // 在这里处理下拉框可见性的变化
    //   // if (visible) {
    //   //   console.log('Compile Version dropdown opened');
    //   //   // 下拉框出现时执行的逻辑
    //   // } else {
    //   //   console.log('Compile Version dropdown closed');
    //   //   // 下拉框关闭时执行的逻辑
    //   // }
    // },
    handleInput() {
      // // 移除非数字字符
      // this.dynamicValidateForm.totalSupply = this.dynamicValidateForm.totalSupply.replace(/\D/g, '');
      // // 限制长度为18
      // if (this.dynamicValidateForm.totalSupply.length > 18) {
      //   this.dynamicValidateForm.totalSupply = this.dynamicValidateForm.totalSupplyslice(0, 18);
      // }
      // // 移除前导零
      // this.dynamicValidateForm.totalSupply = this.dynamicValidateForm.totalSupply.replace(/^0+/, '');
      // // 确保输入为正整数
      // const intValue = parseInt(this.dynamicValidateForm.totalSupply, 10);
      // this.dynamicValidateForm.totalSupply = isNaN(intValue) ? '' : String(Math.max(0, intValue));
      // console.log( this.dynamicValidateForm.totalSupply);
    },
    //停止页面滚动
    stopMove() {
      document.body.style.overflow = "hidden";
      // document.body.style.paddingRight = "17px";
      // console.log(document.documentElement.clientHeight + "px");
    },
    // //开启页面滚动
    Move() {
      document.body.style.overflow = "";
      document.body.style.paddingTop = "112px;";
      // console.log("ccccc", document.body.style.overflow);
    },
    inputvalue() {
      // console.log(this.inputs);
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].value >= 999999999999999999) {
          this.inputs[i].value = this.inputs[i].value;
        }
      }
    },
    erweima() {
      this.flagc = true;
      this.flagb = false;
    },
    showAbi() {
      this.flogsa = true;
    },
    showByte() {
      this.flogsb = true;
    },
    // validateInput(value){
    //   const reg=/^[1,9]\d*$/;
    //   if(!reg.test(value)){
    //     return '请输入正整数';
    //   }
    //   return true;
    // },
    tijiao() {
      this.flogs = true;
      this.Move();
    },
    close2() {
      this.flogsb = false;
    },
    close1() {
      this.flogsa = false;
    },
    close() {
      this.Move();
      this.flogs = false;
    },
    handleChange(file, fileLists) {
      //  console.log("点击了");
      this.isDisabled = false;
    },
    Deploy() {
      if (this.isDisableda == true) {
        // console.log(this.inputs);

        this.flogs = true;
        this.flogsa = false;
        this.flogsb = false;
        //   this.getABIInputEncodeData();
        this.stopMove();
      }
    },
    async submitForm() {
      // console.log(this.nftvalue);
      this.isDisabled = true;
      this.$refs.form.validate(async (success) => {
        if (success) {
          if (this.form.sourceCode.length > 0) {
            axios
              .post(
                "https://explorer.tfsc.io/tfscBrowser/contract/compile",
              //    "http://192.168.1.123:9200/tfscBrowser/contract/compile",
                this.form,
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                // 请求成功状态为200说明添加成功
                // console.log(res);
                // console.log(res.data.code);
                // console.log(res.data.result);

                if (res.data.code == 200) {
                  // console.log(res.code);
                  // this.flogs = true;
                  localStorage.setItem(
                    "oldcompileVersion",
                    this.form.compileVersion
                  );
                  localStorage.setItem("oldstandard", this.form.standard);
                  this.form.compileVersion;
                  //  localStorage.setItem(oldcompileVersion, this.form.compileVersion);
                  this.success = true;
                  this.showabi = res.data.result.abiJson;
                  this.showbyte = res.data.result.byteCode;
                  this.isDisableda = true;
                  // this.isDisabled = false;
                  // this.isDisableda = false;
                  this.Move();
                  //  this.isDisabled = false;
                  // console.log(res.data.result.abiJson);
                  // console.log(JSON.parse(res.data.result.abiJson));
                  const abiJsonlist = JSON.parse(res.data.result.abiJson);
                  for (var i = 0; i < abiJsonlist.length; i++) {
                    if (abiJsonlist[i].type == "constructor") {
                      this.inputsa = abiJsonlist[i].inputs;
                    }
                  }
                  //console.log(this.inputsa);
                  //if(type)
                  this.inputs = JSON.parse(res.data.result.abiJson)[0].inputs;
                  // console.log(this.inputs);
              
                  this.codeerror = "";
                  // for(var i=0;i<this.inputs.length;i++){
                  //   this.inputs[i].value="";
                  // }
                  this.contractUUID = res.data.result.contractUUID;

                  // console.log(JSON.stringify(res.data.result.abiJson));
                  //   this.isDisabled = false;
                  //  this.$router.push("/pc/sucess");

                  // this.$refs.form.resetFields();
                } else if (res.data.code == 400) {
                  this.codeerror = res.data.result;
                  this.success = false;
                  //  this.isDisabled = false;
                  this.isDisableda = false;
                  this.Move();
                  // this.form.sourceCode="";
                  ///this.$refs.form.resetFields();
                  // console.log(res.data.result);
                } else {
                  this.flogs = false;
                  this.form.sourceCode = "";
                  this.$refs.form.resetFields();
                  //this.$refs.form.resetFields();
                  return false;

                  // alert(1111);
                  // this.$message({showClose: true, message: res.result,type: 'error', duration:2000,center:true});
                }
              })
              .catch((error) => {
                //  console.log(error);
                this.$message(" This field are not filled in ");
              });
          } else {
            this.$message("Contract Code   is required");
            //  this.$refs.form.resetFields();
            return false;
          }
        } else {
          this.$message(" This field are not filled in ");
          return false;
        }
      });
    },
    getABIInputEncodeData() {
      // console.log(this.inputs);
      // console.log(this.inputsa);
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].value == "") {
          this.coderesult = " ";
          //this.clearClipboard();
          //   clipboard.destroy();
          // console.log(this.coderesult);

          this.$copyText(this.coderesult).then(
            () => {
              // alert("已复制到剪贴板！11");
              this.$message("Copy failed!");
            },
            () => {
              //  alert("复制失败1323213！");
              this.coderesult = " ";
              // this.clearClipboard();
            }
          );

          this.error = this.inputs[i].name + "" + "is required";

          return false;
        } else {
          this.error = "";

          // this.copycodes();
        }
      }
      this.ispid = 0;
      this.copyresults();

      // this.copyresults();
    },

    copyresults() {
      const forma = {
        inputs: this.inputs,
      };

      axios
        .post(
          "https://explorer.tfsc.io/tfscBrowser/contract/getABIInputEncodeData",
          //   "http://192.168.1.123:9200/tfscBrowser/contract/getABIInputEncodeData",
          forma,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          // console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);
          if (res.data.code == 200) {
            //  this.contentFilled = false;
            this.coderesult = res.data.result;
           // console.log(this.coderesult);
            if (this.ispid == 0) {
              this.$copyText(this.coderesult).then(
                () => {
                  //alert("已复制到剪贴板！");
                  this.$message("Copy successfully!");
                },
                () => {
                  //alert("复制失败！");

                  this.$message("Copy failed!");
                  this.coderesult = " ";
                  // this.clearClipboard();
                }
              );
            }
            // this.$refs.form.resetFields();
          } else if (res.data.code == 400) {
            this.coderesult = " ";
            this.$copyText(this.coderesult).then(
              () => {
                this.$message("Copy failed!");
              },
              () => {
                //alert("复制失败1323213！");
                this.coderesult = " ";
                // this.clearClipboard();
              }
            );
            //this.contentFilled = false;
          }
        })
        .catch((error) => {
          // console.log(error);
          this.$message(" This field are not filled in ");
        });
    },
    async Confirm1() {
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].type == "string") {
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          }
        } else if (this.inputs[i].type == "uint8") {
          const reg = /^[0-9]\d*$/;
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          } else if (reg.test(this.inputs[i].value) == false) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (Number(this.inputs[i].value) > 18) {
            //callback(new Error('请输入1-999999的数字'));
            //   this.message('请输入1-999999的数字)
            this.error =
              this.inputs[i].name + " Please enter a number between 0 and 18 ";

            // this.error=this.inputs[i].name+ "is required"
            return false;
          }
        } else if (this.inputs[i].type == "uint256") {
          const reg = /^[1-9]\d*$/;
          const regs = /^[0-9]\d*$/;
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          } else if (
            regs.test(this.inputs[i].value) == false &&
            (this.inputs[i].name.toLowerCase() !== "_totalsupply" ||
              this.inputs[i].name.toLowerCase() !== "totalsupply")
          ) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (
            reg.test(this.inputs[i].value) == false &&
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply")
          ) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply") &&
            this.nftvalue == true
          ) {
            if (Number(this.inputs[i].value) > 10000) {
              this.error =
                this.inputs[i].name +
                "Please enter a number between 1 and 10000";
              // this.$message(
              //   " _totalSupply Please enter a number between 1 and 10000"
              // );
              return false;
            }
            //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
            //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
          } else if (
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply") &&
            this.nftvalue == false
          ) {
            if (
              Number(this.inputs[i].value) >
              999999999999999999999999999999999999
            ) {
              // this.$message(
              //   " _totalSupply Please enter a number between 1 and 999999999999999999"
              // );
              this.error =
                this.inputs[i].name +
                "Please enter a number between 1 and 999999999999999999";
              return false;
            }
            //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
            //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
          }
          //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
          //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
        }
      }
   //   console.log(this.inputs);
      this.flogs = false;
      this.codefloag = false;
      this.codefloaga = true;
      this.flagc = true;
      this.ispid = 1;
      this.copyresults();
      // this.init();
      this.Move();
    },
    async Confirm() {
      // console.log(this.dynamicValidateForm);
      // console.log(this.inputs);
      // if(this.dynamicValidateForm.contractName==''){
      //   this.$message({
      //     type: 'warning',
      //     message: 'Contract Name is required',
      //     duration: 3000,
      //     customClass: "focus-message",
      //     showClose: true,
      //   });
      //   // this.$message(
      //   //      "Contract Name is required "
      //   //       );
      //         return false;
      // }
      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].type == "string") {
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          }
        } else if (this.inputs[i].type == "uint8") {
          const reg = /^[0-9]\d*$/;
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          } else if (reg.test(this.inputs[i].value) == false) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (Number(this.inputs[i].value) > 18) {
            //callback(new Error('请输入1-999999的数字'));
            //   this.message('请输入1-999999的数字)
            this.error =
              this.inputs[i].name + " Please enter a number between 0 and 18 ";

            // this.error=this.inputs[i].name+ "is required"
            return false;
          }
        } else if (this.inputs[i].type == "uint256") {
          const reg = /^[1-9]\d*$/;
          const regs = /^[0-9]\d*$/;
          if (this.inputs[i].value.toString() == "") {
            //  this.$message(
            //   this.inputs[i].name+ "is required"
            //   );
            this.error = this.inputs[i].name + "is required";
            return false;
          } else if (
            regs.test(this.inputs[i].value) == false &&
            (this.inputs[i].name.toLowerCase() !== "_totalsupply" ||
              this.inputs[i].name.toLowerCase() !== "totalsupply")
          ) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (
            reg.test(this.inputs[i].value) == false &&
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply")
          ) {
            this.error = this.inputs[i].name + "Not a positive integer";
            return false;
          } else if (
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply") &&
            this.nftvalue == true
          ) {
            if (Number(this.inputs[i].value) > 10000) {
              this.error =
                this.inputs[i].name +
                "Please enter a number between 1 and 10000";
              // this.$message(
              //   " _totalSupply Please enter a number between 1 and 10000"
              // );
              return false;
            }
            //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
            //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
          } else if (
            (this.inputs[i].name.toLowerCase() == "_totalsupply" ||
              this.inputs[i].name.toLowerCase() == "totalsupply") &&
            this.nftvalue == false
          ) {
            if (
              Number(this.inputs[i].value) >
              999999999999999999999999999999999999
            ) {
              // this.$message(
              //   " _totalSupply Please enter a number between 1 and 999999999999999999"
              // );
              this.error =
                this.inputs[i].name +
                "Please enter a number between 1 and 999999999999999999";
              return false;
            }
            //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
            //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
          }
          //判断里面含没含_totalSupply 如果含_totalSupply而且nftvalue为1的时候表示合约里面含有nft如果nftvalue为0的时候表示合约里面没有含nft的内容
          //当nftvalue为1的时候他的最大值是10000当为0的时候最大值是999999999999999999
        }
        // if((this.inputs[i].value).toString()==''){
        //      this.$message(
        //       this.inputs[i].name+ "is required"
        //       );
        //       return false;
        // }else

        // if((this.inputs[i].type=='uint256'||this.inputs[i].type=='uint8')&& isPositiveInteger(this.inputs[i].value)==false){
        //   this.$message(
        //       this.inputs[i].name+ " Please enter a positive integer."
        //   );
        //   return false;
        // }else
        //

        //  if (this.inputs[i].name == "_decimals" || this.inputs[i].name == "decimal" || this.inputs[i].name == "Decimal" ) {
        //   if (Number(this.inputs[i].value) >18) {

        //       this.$message(
        //         "_decimals Please enter a number between 0 and 18 "
        //       );
        //       return false;
        //     }else{
        //       this.numbers=Number(this.inputs[i].value);
        //       console.log(this.numbers);
        //     }
        // } else if (this.inputs[i].name == "_totalSupply" || this.inputs[i].name == "totalSupply" || this.inputs[i].name == "TotalSupply") {
        //   if (Number(this.dynamicValidateForm.totalSupply) >999999999999999999) {

        //       this.$message(
        //         " _totalSupply Please enter a number between 1 and 999999999999999999"
        //       );
        //       return false;
        //    }else{
        //     if(this.numbers>0){
        //     console.log( (this.numbersa.slice(0,this.numbers)));
        //     console.log(this.dynamicValidateForm.totalSupply);
        //     this.totalSupply=Number(this.dynamicValidateForm.totalSupply)+this.numbersa.slice(0,this.numbers);
        //     this.inputs[i].value=this.totalSupply;
        //     console.log( this.totalSupply);
        //     }else{
        //       this.totalSupply=Number(this.dynamicValidateForm.totalSupply);
        //       this.inputs[i].value=this.totalSupply;
        //       console.log(this.totalSupply);
        //     }
        //    }
        // }
      }

      //  console.log(this.inputs);
      this.forma = {
        contractUUID: this.contractUUID,
        inputJson: this.inputs,
        //contractName: this.dynamicValidateForm.contractName,
      };

      //  console.log(this.forma);
    
      axios
        .post(
         "https://explorer.tfsc.io/tfscBrowser/contract/saveTempContractInfo",
        //  "http://192.168.1.123:9200/tfscBrowser/contract/saveTempContractInfo",
          this.forma,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          // console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);
          if (res.data.code == 200) {
            // console.log(res.code);
            // this.codefloag = false;
            this.flogs = false;
            this.codefloag = false;
            this.codefloaga = true;
            this.flagc = true;
            // this.init();
        
            this.Move();
            //this.form.sourceCode="";
            // this.$refs.form.resetFields();
          } else {
            // this.$refs.form.resetFields();
            this.Move();
            return false;
          }
        })
        .catch((error) => {
          // console.log(error);
          this.$message(" This field are not filled in ");
        });
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["sol", "txt", "text"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$msg("上传文件只能是 pdf、doc、docx、xls、xlsx格式", "error");
        this.$message("File uploads must be in the sol、txt format.");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message("File uploads must not exceed 2MB in size.", "error");
        return false;
      }
    },
    // 上传成功
    upSuccess(res, file) {
      this.error = "";
      this.codeerror = "";
      this.$refs.upload.clearFiles();
      this.jsonfileName = file.name;
      this.uploadSuccess = true;
      // let val=''
      let reader = new FileReader();
      reader.readAsText(file.raw, "UTF-8"); //读取，转换字符编码
      let vm = this;
      reader.onload = function (e) {
        vm.form.sourceCode = e.target.result; //获取数据
        this.isDisableda = false;
        this.isDisabled = false;
        //console.log(vm.form.sourceCode);
      };
    },
    // 上传失败
    upError(e) {
      this.$message("error", "error");
    },
    codeChange(val) {
      val;
      //  console.log(val)
      const lowerCaseCode = val.toLowerCase();
      if (lowerCaseCode.includes("nft")) {
        // console.log("上传的内容包含 'nft'");
        this.nftvalue = true;
        this.nftshow = true;
      } else {
        //  console.log("上传的内容不包含 'nft'");
        this.nftvalue = false;
        this.nftshow = false;
      }
      this.isDisableda = false;
      this.success = false;
      //this.dynamicValidateForm.contractName="";
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
      require("brace/mode/python");
    },

    init() {
      this.Address = "TTOSCONTRACTUUID:" + this.contractUUID;
      //  console.log(this.Address);
      //  const that = this
      const width = (window.innerWidth / 100) * 40; // 此行代码表示二维码的宽度为屏幕宽度的40%，width 不支持百分比、不同设备的像素不一样所以此处这样写
      // 此处可以根据业务进行异步处理，动态获取二维码参数，刷新二维码
      // let qrCodeContent = this.Address; // 伪代码
      // console.log(qrCodeContent);
      // 先清除二维码再重新生成
      if (this.qrcode.clear) {
        // this.qrcode.clear()
        this.$refs.qrcode.innerHTML = "";
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: this.Address, //二维码内容字符串
        width: 160, //图像宽度
        height: 160, //图像高度
        colorDark: "#000", //二维码前景色
        colorLight: "#fff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别
      });
      this.qrcode._el.title = "";
    },
    //二维码
    paids() {
      this.forma = {
        contractUUID: this.contractUUID,
      };
      //  console.log(this.forma);
      let formData = new FormData();
      let item = this.forma;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      axios
        .post(
          //"https://explorer.tfsc.io/tfscBrowser/contract/checkSuccessContractInfo",
          "http://192.168.1.123:9200/tfscBrowser/contract/checkSuccessContractInfo",
          formData
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          // console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);
          if (res.data.code == 200) {
            if (res.data.result == 0) {
              // console.log(res.code);
              // this.codefloag = false;
              //  this.dynamicValidateForm.contractName="";
              this.flagb = true;
              //    this.flaga = true;
              this.flaga = false;
              this.flagc = false;
              this.Move();
            } else if (res.data.result == 1) {
              // this.$refs.form.resetFields();
              this.$refs.form.resetFields();
              this.form.sourceCode = "";
              this.isDisableda = false;
              this.Move();
              //   this.dynamicValidateForm.contractName="";
              this.success = false;
              this.flaga = true;
              this.flagb = false;
              this.flagc = false;
              //  this.$refs.form.resetFields();
            }
          } else if (res.data.code == 400) {
            this.flagb = true;
            //    this.flaga = true;
            this.flaga = false;
            this.flagc = false;
            this.$message(res.data.result);
            this.Move();
          }
        })
        .catch((error) => {
          //console.log(error);
          this.$message(" This field are not filled in ");
        });
    },
    black() {
      this.codefloag = true;
      //alert(123);
      this.codefloaga = false;
      this.flaga = false;
      this.flagb = false;
      this.flagc = false;
      this.form.compileVersion = "";
      this.form.sourceCode = "";
      this.$refs.form.resetFields();
      //this.paids();
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
  },
};
</script>
<style lang="less">
// /deep/.el-input__inner{
//   color: #ffffff !important;
// }
// /deep/.el-input__inner::placeholder {
//    color: rgba(255, 255, 255, 0.5) !important;
// }
.el-message {
  margin-top: 30px !important;
  z-index: 999999999 !important;
}
</style>
<style lang="less" scoped>
/deep/.ace_layer {
  // background: #181b21;
  //color: #008f21!important;
  // background: red;
  // background: #13161b !important;
}
/deep/.el-input__inner {
  width: 300px;
  height: 40px;
  // background: #13161b;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  border: none;
}
/deep/.el-button {
  width: 141px;
  height: 42px;
  text-align: center;
  //line-height: 42px;
  background: #1c1e24;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  border: none !important;
  font-size: 14px;
  font-family: Roboto, Roboto;
  font-weight: 500;
  color: #ffffff;
}
/deep/ ul {
  padding: 0px !important;
}
/deep/ .el-select-dropdown__list {
  background-color: #000 !important;
  border: none !important;
}
/deep/ .el-select-dropdown__list {
  background: #000 !important;
}
/deep/ .el-select-dropdown {
  border: none !important;
}
/deep/.el-select-dropdown__item {
  // margin-top: -6px !important;
  // height: 42px !important;
  // line-height: 50px !important;
}
/deep/.el-select-dropdown__item.selected {
  color: #4b4c52 !important;
  font-size: 12px;
}
/deep/ .el-select-dropdown__item.hover {
  background-color: #1395ff !important;
  color: #fff !important;
}
// /deep/ .el-select-dropdown__item.selected {
//   color: #008f21;
// }
/deep/ .el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #13161b;
}
/deep/.ace_gutter-layer {
  background: #181b21 !important;
}
/deep/.ace-github {
  color: #008f21 !important;
}
/deep/.ace_editor {
  background: #181b21 !important;
}
/deep/.ace-github .ace_gutter {
  background: #181b21 !important;
  // color: #0d5eff !important;

  color: #4b4c52 !important;
}
/deep/.el-dialog__header {
  display: none;
  padding: 0px !important;
}
/deep/.el-dialog__body {
  padding: 0px !important;
}
/deep/::-webkit-scrollbar {
  width: 0px !important; /*滚动条宽度*/
  height: 8px; /*滚动条高度*/
}
/deep/.el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: rgba(168, 168, 168, 0.4); /*滚动条默认显示的颜色*/
}

/deep/.el-textarea__inner::-webkit-scrollbar {
  width: 0px !important;
  height: 8px;
  // background-color: white; /*滚动条背景色显示的颜色*/
}
input {
  border: none;
}
/deep/.el-textarea__inner {
  border: none !important;
  /* width: 806px; */
  height: 361px;
  // background: #fff !important;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;

  background: #13161b !important;
  /* color: #fff !important; */
  /* margin-left: 150px */
}
/deep/.el-select-dropdown__wrap {
  margin-bottom: -6px !important;
}
</style>
<style lang="less" scoped>
.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1160px;
    height: 1250px;
    background: #000000;
    opacity: 1;
    border-radius: 20px;
    margin: 0 auto;
    margin-top: 20px;
    .Contract {
      padding-top: 19px;
      margin-left: 40px;
      .Contract_tit {
        height: 25px;
        font-size: 21px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        span {
        }
      }
      .Contract_con {
        //border: 1px solid red;
        margin-right: 40px;
        .Contract_icon {
        }
        .Contract_content {
          margin-top: 12px;
          height: 36px;
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 18px;
        }
      }
      .Contract_con1 {
        margin-top: 40px;
        .elheader {
          span {
          }
        }
        .elcontent {
        }
        .Contractbox {
        }
        .Contractboxs {
          .Contractboxli {
            display: flex;
            height: 60px;
            .Contractboxli_tit {
              // height: 19px;
              font-size: 16px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #898b8d;
              line-height: 40px;
              width: 200px;
              height: 50px;
              // margin-right: 54px;
            }
            // .Contractboxli_con{
            //   background: #000000;
            //   border: 1px solid red;
            // }
          }
        }
        .Contractboxlis {
          // border: 1px solid red;
          margin-right: 40px;
          // margin-top: 26px;
          .Contractboxli_tits {
            display: flex;
            justify-content: space-between;
            .Contractboxli_titsl {
              width: 218px;
              height: 40px;
              line-height: 40px;
              background: #000000;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              font-size: 18px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #ffffff;
            }
            .Contractboxli_titsr {
              img {
                margin-top: 10px;
                width: 24px;
                height: 24px;
                margin-right: 8px;
              }
            }
          }
          .Contractboxli_cons {
            margin-top: 15px;
            width: 1080px;
            height: 673px;
            background: #0d0f12;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
          }

          .Contractboxli_consa {
            width: 1080px;
            height: 207px;
            //background: #0d0f12;
            background: #181b21;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            margin-top: 10px;
            .Contractboxli_header {
              display: flex;
              padding-top: 24px;
              margin-bottom: 12px;
              .con_tit {
                margin-left: 20px;
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #00983d;
              }
              .con_con {
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #00983d;
                line-height: 20px;
                margin-left: 18px;
              }
              .con_btn {
                // width: 81px;
                height: 25px;
                line-height: 25px;
                background: rgba(44, 205, 41, 0.2);
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                border: 1px solid #2ccd29;
                font-size: 13px;
                font-family: Roboto, Roboto;
                font-weight: 600;
                color: #03a100;
                text-align: center;
                padding-left: 8px;
                padding-right: 8px;
                margin-left: 40px;
                cursor: pointer;
              }
              .con_btn1 {
                margin-left: 24px !important;
              }
            }
            .Contractboxli_content {
              margin-left: 20px;
              .con_cont1 {
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #a700e5;
                line-height: 20px;
                margin-bottom: 12px;
              }
              .con_cont2 {
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #a700e5;
                line-height: 20px;
                display: flex;
                margin-bottom: 12px;
                .con_conbtton {
                  margin-left: 40px;
                  width: 200px;
                  height: 25px;
                  background: rgba(206, 76, 255, 0.2);
                  border-radius: 6px 6px 6px 6px;
                  opacity: 1;
                  border: 1px solid #ce4cff;
                  font-size: 13px;
                  font-family: Roboto, Roboto;
                  font-weight: 600;
                  color: #b018e8;
                  padding-left: 10px;
                  padding-right: 10px;
                }
              }
              .con_cont3 {
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #a700e5;
                line-height: 20px;
                margin-bottom: 12px;
                margin-top: 10px;
              }
              .con_cont4 {
                margin-top: 10px;
                height: 20px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #ea5200;
                line-height: 20px;
                margin-bottom: 12px;
                padding-top: 20px;
              }
            }
          }
        }
        .Contractboxli_button {
          display: flex;
          margin-top: 20px;
          .button {
            width: 121px;
            height: 42px;
            line-height: 42px;
            background: #181b21;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            text-align: center;
            font-size: 14px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
            margin-right: 20px;
          }
          .button1 {
            width: 128px;
            height: 42px;
            line-height: 42px;
            background: rgba(19, 22, 27, 0.5);
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            text-align: center;
            font-size: 14px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.5);
            margin-right: 20px;

            cursor: pointer;
          }
        }
      }
    }
    .tankuangbox {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
      // height: 1000px !important;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      overflow: auto;
      .tankuanglist {
        width: 488px;
        // height: 397px;
        background: #13161b;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding-bottom: 20px;
        .tankuanghead {
          width: 488px;
          height: 52px;
          background: #13161b;
          opacity: 1;
          display: flex;
          justify-content: space-between;
          border-radius: 10px 10px 0px 0px;
          cursor: pointer;
          .tantit {
            font-size: 19px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #ffffff;
            line-height: 60px;
            margin-left: 24px;
          }
          img {
            width: 24px;
            height: 24px;
            margin-top: 14px;
            margin-right: 20px;
          }
        }
        .tankuangconts {
          width: 438px;
          margin: 0 auto;
          // padding-top: 20px;
          // padding-bottom: 30px;
          .verfery_li {
            .verfery_litit {
              font-size: 16px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #ffffff;
              margin-bottom: 8px;
            }
            .verfery_licon1 {
              display: flex;
              .inpttext {
                width: 408px;
                // border: 1px solid red;
                // background: #000000;
              }
              .inpttext1 {
                width: 300px !important;
                margin-left: 20px;
                // border: 1px solid red;
                width: 300px;
                height: 40px;
                background: #000000;
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
              }
              /deep/.el-input__inner {
                width: 300px;
                height: 40px;
                background: #000000 !important;
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                font-size: 14px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                // color: rgba(137, 139, 141, 0.7);
                color: #fff;
              }
              /deep/.el-input__inner::placeholder {
                color: rgba(255, 255, 255, 0.4) !important;
              }
              /deep/ .el-textarea__inner {
                //color: #999;
                color: #fff;
              }
              .vername {
                width: 120px;
                height: 29px;
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #898b8d;
                line-height: 29px;
                text-align: right;
              }
            }
            .errorbox {
              width: 408px;
              margin: 0 auto;
              height: 40px;
              font-size: 14px;
              font-family: Roboto, Roboto;
              font-weight: 500;
              color: red;
              // border: 1px solid red;
            }
            .btnflex {
              display: flex;
              .tip {
                width: 143px;
                height: 73px;
                background: #000000;
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                margin-top: -20px;
                .tipcon {
                  width: 123px;
                  margin: 0 auto;
                  height: 57px;
                  font-size: 13px;
                  font-family: Roboto, Roboto;
                  font-weight: 400;
                  color: #898b8d;
                  word-spacing: -1px;
                  line-height: 19px;
                  margin-top: 8px;
                }
              }
              .arrow {
                display: inline-block;
                width: 0;
                height: 0;
                border: 8px solid;
                border-color: #13161b #13161b #13161b #000;
                margin-top: 10px;
              }
              .verfery_copy {
                width: 127px;
                height: 42px;
                line-height: 42px;
                cursor: pointer;
                display: flex;
                img {
                  width: 14px;
                  height: 14px;
                  margin-top: 12px;
                  // margin-left: 18px;
                  margin-right: 7px;
                }
                div {
                  font-size: 14px;
                  font-family: Roboto, Roboto;
                  font-weight: 500;
                  color: #04bd80;
                }
              }
              .verfery_btn {
                // width: 187px;
                // height: 44px;
                // line-height: 44px;
                // text-align: center;
                // background: #1394ff;
                // border-radius: 6px 6px 6px 6px;
                // opacity: 1;
                width: 127px;
                height: 42px;
                line-height: 42px;
                background: rgba(0, 231, 154, 0.8);
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                text-align: center;
                font-size: 14px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #000000;
                margin: 0 auto;
                cursor: pointer;
                padding-bottom: 30px;
              }
            }
          }
        }
        .tankuang_btn {
          display: flex;
          .tan_close {
            width: 73px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            //  background: rgba(19, 149, 255, 0.2);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            // border: 1px solid #1395ff;
            font-size: 13px;
            font-family: Roboto, Roboto;
            font-weight: 600;
            // color: #1395ff;
            color: #04bd80;
            margin-left: 246px;
            cursor: pointer;
          }
          .tan_copy {
            width: 107px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background: rgba(0, 231, 154, 0.8);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            font-size: 14px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #000000;
            margin-left: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .BlockList-Wa {
    height: 800px;

    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 9999;

    width: 100%;
    height: 100%;
    overflow: auto;
    //插件钱包连接开始
    .Connection {
      position: absolute;
      left: 50%;
      top: 36%;
      transform: translate(-50%, -36%);
      width: 690px;
      height: 333px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      margin-top: 40px;
      .Connection_w {
        width: 690px;
        height: 333px;
        background: #000000;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        .Connection_box {
          padding-top: 23px;
          width: 586px;
          margin: 0 auto;
          .Connection_tit {
            height: 20px;
            font-size: 17px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            text-align: center;
          }
          .Connection_erwm {
            margin-top: 49px;
            display: flex;
            .con_box {
              margin-left: 248px;
              margin-right: 40px;
              .treeimg {
                background: url("../../../assets/pc/Index/treecon.png") center
                  no-repeat;
                background-size: cover;
                width: 120px;
                height: 147px;
              }
              .treeimg:hover {
                background: url("../../../assets/pc/Index/treecona.png") center
                  no-repeat;
                background-size: cover;
                width: 120px;
                height: 147px;
              }
              .treetit {
                font-size: 13px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #ffffff;
                line-height: 15px;
                text-align: center;
                margin-bottom: 30px;
                margin-top: 20px;
              }
            }
            .con_box1 {
              .treeimg1 {
                width: 52px;
                height: 52px;
                img {
                  width: 52px;
                  height: 52px;
                  margin-left: 27px;
                }
              }
              .treetit1 {
                font-size: 13px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #ffffff;
                line-height: 15px;
                text-align: center;
                margin-top: 20px;
              }
            }
          }
          .Connection_botm {
            font-size: 12px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;
            word-spacing: 0px;
            margin-top: 40px;
            span {
              font-size: 12px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              word-spacing: 0px;
              color: #00e79a;
              margin-left: 4px;
            }
          }
        }
      }
    }

    //插件钱包连接结束
    //弹框的内容开始
    .paidbox {
      position: absolute;
      left: 50%;
      top: 36%;
      transform: translate(-50%, -36%);
      width: 690px;
      height: 413px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      margin-top: 40px;
      .paidboxlist {
        width: 690px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;
        .paidboxtit {
          font-size: 17px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
        .qrcodea {
          width: 180px;
          height: 180px;
          border: 10px solid #fff;
          margin-left: 228px;
          margin-top: 30px;
          margin-bottom: 30px;
          .qrcode {
            width: 180px;
            height: 180px;
            // border: 1px solid red;
          }
        }
        .button {
          width: 198px;
          height: 42px;
          line-height: 42px;
          background: rgba(0, 231, 154, 0.8);
          border-radius: 6px 6px 6px 6px;
          opacity: 1;

          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #000000;

          text-align: center;
          margin-left: 220px;
          margin-bottom: 14px;
          cursor: pointer;
        }
        .bottom {
          display: flex;
          margin-left: 206px;
          .bottomtit {
            font-size: 15px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #ffffff;
            margin-right: 6px;
            cursor: pointer;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .paidbox1 {
      position: absolute;

      left: 50%;
      top: 30%;
      transform: translate(-50%, -30%);
      width: 690px;
      height: 222px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      // width: 1384px;
      // height: 350px;
      // background: #ffffff;
      // border-radius: 10px 10px 10px 10px;
      // opacity: 1;
      // border: 2px solid rgba(201, 219, 255, 0.8);
      margin: 0 auto;
      .paidboxlist {
        width: 646px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;
        .paidtit1 {
          font-size: 19px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
          .imga {
          }
        }
        .paidtit2 {
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          margin-top: 20px;
          margin-bottom: 40px;
        }
        .paidtitbtn {
          width: 92px;
          height: 43px;
          background: rgba(0, 231, 154, 0.8);
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          line-height: 43px;
          text-align: center;
          margin: 0 auto;
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #000000;
          cursor: pointer;
        }
      }
    }
    .paidbox2 {
      width: 727px;
      height: 297px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      position: absolute;
      left: 50%;
      top: 30%;
      transform: translate(-50%, -30%);
      // opacity: 1;
      // border: 2px solid rgba(201, 219, 255, 0.8);
      margin: 0 auto;
      .paidboxlist {
        width: 727px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;

        .paidtit3 {
          font-size: 15px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 18px;
          text-align: left;
          margin-left: 64px;
        }
        .paidtit4 {
        }
        .paidtit1 {
          font-size: 19px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
        }
        .paidtit2 {
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 29px;
          margin-top: 18px;
          text-align: left;
          margin-left: 64px;
        }
        .paidtitbtn {
          width: 92px;
          height: 43px;
          background: rgba(0, 231, 154, 0.8);
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          line-height: 43px;
          text-align: center;
          margin: 0 auto;
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #000000;
          cursor: pointer;
          margin-top: 27px;
        }
        .paidtitbottom {
          display: flex;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          margin-top: 14px;
          .bottomtit {
            font-size: 15px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #ffffff;
            margin-right: 6px;
            cursor: pointer;
          }
        }
      }
    }
    //弹框的内容结束
  }
}
</style>

<style lang="less" scoped>
/deep/::-webkit-scrollbar {
  width: 0px !important; /*滚动条宽度*/
  height: 8px; /*滚动条高度*/
}
.el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: rgba(168, 168, 168, 0.4); /*滚动条默认显示的颜色*/
}

/deep/.el-textarea__inner::-webkit-scrollbar {
  width: 0px !important;
  height: 8px;
  background-color: white; /*滚动条背景色显示的颜色*/
}
input {
  border: none;
}
/deep/.el-button {
  background: #181b21 !important;
  border: none !important;
  color: #fff;
  width: 165px;
  height: 34px;

  border-radius: 6px 6px 6px 6px;
  opacity: 1;
}

/deep/.el-button {
  background-color: #181b21 !important;
  border: none !important;
  color: #fff;
}
/deep/.el-upload-list {
  display: none !important;
}
/deep/ button:hover {
  color: #06c083 !important;
}

/deep/ .el-select-dropdown__wrap {
  background: #181b21 !important;
}

/deep/ .el-select-dropdown {
  border: none !important;
  background: #181b21 !important;
  padding: 0px 0px !important;
}
/deep/.el-select-dropdown__item.hover {
  background-color: #000 !important;
}
/deep/.el-select-dropdown__item.selected {
  color: #06c083 !important;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #181b21;
}
/deep/.el-input__inner {
  background-color: #181b21 !important;
  border: none;
  color: #fff;
}
</style>
